import React, { useState } from "react";
import "./PostponeModal.css";
import axios from "axios";

const PostponeModal = ({ closeModal, booking, onRequestSubmitted }) => {
const [newStartDate, setNewStartDate] = useState("");
const [newEndDate, setNewEndDate] = useState("");
  const [reason, setReason] = useState("");

  const user = JSON.parse(localStorage.getItem("hm_user"));

  const submitRequest = async () => {
    if (!newStartDate || !newEndDate || !reason) {
  alert("Please fill all fields");
  return;
}
if (newEndDate < newStartDate) {
    alert("End date cannot be earlier than start date");
    return;
  }
const combinedDate = `${newStartDate} - ${newEndDate}`;

try {
  const res = await axios.post("/api/postpone/create", {
    bookingId: booking._id,
    userId: user._id,
    oldDate: booking.tripDate,
    newDate: combinedDate, // send combined string to backend
    reason,
  });

    if (res.data.success) {
  alert("Postpone request submitted!");
  
  // Update booking in parent component (Account.js)
  onRequestSubmitted?.({ ...booking, newDate: combinedDate, postponeStatus: 'pending' });

  closeModal();
}

    } catch (err) {
      console.log(err);
      alert("Error submitting postpone request");
    }
  };

  return (
    <div className="postpone-modal-overlay">
      <div className="postpone-modal">
        <h2>Request Postpone</h2>

        <p><strong>Current Trip Date:</strong> {booking.tripDate}</p>

      <label>New Start Date:</label>
<input 
  type="date" 
  value={newStartDate} 
  onChange={(e) => setNewStartDate(e.target.value)} 
/>

<label>New End Date:</label>
<input 
  type="date" 
  value={newEndDate} 
  onChange={(e) => setNewEndDate(e.target.value)} 
/>


        <label>Reason:</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Explain why you want to postpone"
        />

        <div className="postpone-actions">
          <button className="postpone-cancel-btn" onClick={closeModal}>Cancel</button>
          <button className="postpone-submit-btn" onClick={submitRequest}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default PostponeModal;
